export default 'Deactivations';
